import EditableResult from '../../../components/EditableResult';
import EditableResultSwitch from '../../../components/EditableResultSwitch';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Autocomplete from "react-google-autocomplete";
import { Textareawithsteroids3 } from "../EUGreenDeal/EUGreenDeal";
import edit from '../../../assets/shapes_svg/roledetail/edit.svg';
import { useState, useEffect } from 'react';
import { createHighlight, getHighlight, updateHighlight } from '../../../apis/Ambition';
import '../index.css';
import './index.css';
import { useTranslation } from 'react-i18next';


const SME = () => {
    const { t } = useTranslation()

    const [companyName, setCompanyName] = useState("");
    const [companyContactName, setCompanyContactName] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [companyPhone, setCompanyPhone] = useState("");
    const [companyLocation, setCompanyLocation] = useState("");
    const [corporateWebsite, setCorporateWebsite] = useState("");
    const [twitterLink, setTwitterLink] = useState("");
    const [linkedinLink, setLinkedinLink] = useState("");
    const [otherSocialLink, setOtherSocialLink] = useState("");
    const [submitCommitLetter, setSubmitCommitLetter] = useState(false);
    const [isinNumber, setIsinNumber] = useState("");
    const [sector, setSector] = useState("");
    const [reit, setReit] = useState(false);
    const [financialInst, setFinancialInst] = useState(false);
    const [companyRevenue, setCompanyRevenue] = useState(false);

    const [editCompanyName, setEditCompanyName] = useState(false);
    const [editCompanyContactName, setEditCompanyContactName] = useState(false);
    const [editCompanyEmail, setEditCompanyEmail] = useState(false);
    const [editCompanyPhone, setEditCompanyPhone] = useState(false);
    const [editCompanyLocation, setEditCompanyLocation] = useState(false);
    const [editCorporateWebsite, setEditCorporateWebsite] = useState(false);
    const [editTwitterLink, setEditTwitterLink] = useState(false);
    const [editLinkedinLink, setEditLinkedinLink] = useState(false);
    const [editOtherSocialLink, setEditOtherSocialLink] = useState(false);
    const [editSubmitCommitLetter, setEditSubmitCommitLetter] = useState(false);
    const [editIsinNumber, setEditIsinNumber] = useState(false);
    const [editSector, setEditSector] = useState(false);
    const [editReit, setEditReit] = useState(false);
    const [editFinancialInst, setEditFinancialInst] = useState(false);
    const [editCompanyRevenue, setEditCompanyRevenue] = useState(false);

    const fields = [
        {'name':'submitcommitlettersme','setValue':setSubmitCommitLetter,'edit':editSubmitCommitLetter,'value':submitCommitLetter},
        {'name':'reitsme','setValue':setReit,'edit':editReit,'value':reit},
        {'name':'financialinstsme','setValue':setFinancialInst,'edit':editFinancialInst,'value':financialInst},
        {'name':'companyrevenuesme','setValue':setCompanyRevenue,'edit':editCompanyRevenue,'value':companyRevenue},
    ]

    const updateField = ({action='update', valueName, value}) => {
        if(action !== 'update'){
            createHighlight({key:valueName,value:value})
        }
        else{
            updateHighlight({
                key:valueName,
                value:value,
                swal:false
            })
        }    
    }

    useEffect(() => {
        fields.map((field) => {
            getHighlight({
                key:field.name,
                setValue:field.setValue
            })
            
        })
    }, []) 

    useEffect(() => {
        fields.map((field) => {
            if(field.edit){
                updateField({
                    valueName:field.name, 
                    value:field.value,
                })
            }
        })
    }, [submitCommitLetter, reit, financialInst, companyRevenue])

    return (
        <>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Company name</h5>
            <div className="sbti__inputs">
                { editCompanyName ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'company_name'} placeholder="Company Name"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'company_name'} disabled={true} placeholder="Company Name"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCompanyName(!editCompanyName)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Primary company contact name<br/><br/><em>This will be the main point of contact for technical questions during the validation process</em></h5>
            <div className="sbti__inputs">
                { editCompanyContactName ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'company_contact_name'} placeholder="Company Contact Name"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'company_contact_name'} disabled={true} placeholder="Company Contact Name"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCompanyContactName(!editCompanyContactName)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Primary contact email (-s)</h5>
            <div className="sbti__inputs">
                { editCompanyEmail ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'company_email'} placeholder="Company Email"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'company_email'} disabled={true} placeholder="Company Email"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCompanyEmail(!editCompanyEmail)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Primary company contact phone number (optional)</h5>
            <div className="sbti__inputs">
                { editCompanyPhone ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'company_phone'} placeholder="Company Phone"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'company_phone'} disabled={true} placeholder="Company Phone"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCompanyPhone(!editCompanyPhone)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Company's HQ location</h5>
            <div className="sbti__inputs">
                { editCompanyLocation ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'company_location'} placeholder="Company Location"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'company_location'} disabled={true} placeholder="Company Location"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCompanyLocation(!editCompanyLocation)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Corporate website</h5>
            <div className="sbti__inputs">
                { editCorporateWebsite ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'corporate_website'} placeholder="Corporate Website"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'corporate_website'} disabled={true} placeholder="Corporate Website"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCorporateWebsite(!editCorporateWebsite)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Social media links (optional)</h5>
            <div style={{display:"flex",flexDirection:"column", width:"47%"}}>
                <div style={{display:"flex",flexDirection:"row"}}>
                    <div className="sbti__inputs" style={{width:"100%"}}>
                        { editTwitterLink ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'twitter'} placeholder="Twitter"/>
                        : <Textareawithsteroids3 maxLength={50} keyHighlight={'twitter'} disabled={true} placeholder="Twitter"/>
                        }
                    </div>
                    <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditTwitterLink(!editTwitterLink)}/>
                </div>
                <div style={{display:"flex",flexDirection:"row"}}>
                    <div className="sbti__inputs" style={{width:"100%"}}>
                        { editLinkedinLink ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'linkedin'} placeholder="Linkedin"/>
                        : <Textareawithsteroids3 maxLength={50} keyHighlight={'linkedin'} disabled={true} placeholder="Linkedin"/>
                        }
                    </div>
                    <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditLinkedinLink(!editLinkedinLink)}/>
                </div>
                <div style={{display:"flex",flexDirection:"row"}}>
                    <div className="sbti__inputs" style={{width:"100%"}}>
                        { editOtherSocialLink ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'other_social'} placeholder="Other"/>
                        : <Textareawithsteroids3 maxLength={50} keyHighlight={'other_social'} disabled={true} placeholder="Other"/>
                        }
                    </div>
                    <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditOtherSocialLink(!editOtherSocialLink)}/>
                </div>
            </div>
            
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Has your company ever submitted a commitment letter to the SBTi ?</h5>
            <div className="sbti__inputs">
                { editSubmitCommitLetter ? 
                <EditableResultSwitch
                    result={submitCommitLetter}
                    edit={true}
                    changeTo={submitCommitLetter}
                    setValue={setSubmitCommitLetter}
                    choice1={'Yes'}
                    choice2={'No'}
                    autosave={true}
                    styleNo={1}
                />
                : <h5 style={{textAlign:"center"}}>{submitCommitLetter}</h5>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditSubmitCommitLetter(!editSubmitCommitLetter)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>ISIN number</h5>
            <div className="sbti__inputs">
                { editIsinNumber ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'isin_number'} placeholder="ISIN Number"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'isin_number'} disabled={true} placeholder="ISIN Number"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditIsinNumber(!editIsinNumber)}/>
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Sector</h5>
            <div className="sbti__inputs">
                { editSector ?
                    <Textareawithsteroids3 maxLength={50} keyHighlight={'sector'} placeholder="Sector"/>
                : <Textareawithsteroids3 maxLength={50} keyHighlight={'sector'} disabled={true} placeholder="Sector"/>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditSector(!editSector)}/>
        </div>
        <div onClick={()=> {
                    
            }} style={{position:"relative",cursor:"pointer",top:"6vh",left:"1vw"}}>
                <InfoOutlinedIcon />
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Are your company a mortgage REIT? (Finansical institution?</h5>
            <div className="sbti__inputs">
                { editReit ? 
                <EditableResultSwitch
                    result={reit}
                    edit={true}
                    changeTo={reit}
                    setValue={setReit}
                    choice1={'Yes'}
                    choice2={'No'}
                    autosave={true}
                    styleNo={1}
                />
                : <h5 style={{textAlign:"center"}}>{reit}</h5>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditReit(!editReit)}/>
        </div>
        <div onClick={()=> {
                    
                }} style={{position:"relative",cursor:"pointer",top:"6vh",left:"1vw"}}>
                    <InfoOutlinedIcon />
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Are your company a finansical institution?</h5>
            <div className="sbti__inputs">
            { editFinancialInst ? 
                <EditableResultSwitch
                    result={financialInst}
                    edit={true}
                    changeTo={financialInst}
                    setValue={setFinancialInst}
                    choice1={'Yes'}
                    choice2={'No'}
                    autosave={true}
                    styleNo={1}
                />
                : <h5 style={{textAlign:"center"}}>{financialInst}</h5>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditFinancialInst(!editFinancialInst)}/>
        </div>
        <div onClick={()=> {
                    
                }} style={{position:"relative",cursor:"pointer",top:"6vh",left:"1vw"}}>
                    <InfoOutlinedIcon />
        </div>
        <div className="sbti__fields">
            <h5 className="sbti__labels" style={{textAlign:"center"}}>Are you a company with more than 50% revenue from the sales, transmission, or distribution of fossil fuels</h5>
            <div className="sbti__inputs">
            { editCompanyRevenue ? 
                <EditableResultSwitch
                    result={companyRevenue}
                    edit={true}
                    changeTo={companyRevenue}
                    setValue={setCompanyRevenue}
                    choice1={'Yes'}
                    choice2={'No'}
                    autosave={true}
                    styleNo={1}
                />
                : <h5 style={{textAlign:"center"}}>{companyRevenue}</h5>
                }
            </div>
            <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditCompanyRevenue(!editCompanyRevenue)}/>
        </div>
        </>
    )
}

export default SME;